package com.karyadina.ui.theme

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.Assignment
import androidx.compose.material.icons.filled.*
import androidx.compose.material.icons.outlined.CheckBoxOutlineBlank
import androidx.compose.material.icons.outlined.Delete
import androidx.compose.material.icons.outlined.Edit
import androidx.compose.material.icons.outlined.TaskAlt
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import com.karyadina.common.generated.resources.Res

import com.karyadina.* // Auto-generated by Gradle
import com.karyadina.common.generated.resources.* // Auto-generated by Gradle


// 1. Icon System (Abstracts Material Icons vs Custom SVGs)
object StudyIcons {
    val ArrowBack = Icons.AutoMirrored.Filled.ArrowBack // Top App Bar
    val SessionTab = Icons.Filled.CalendarToday
    val SubjectTab = Icons.Filled.School
    val Add = Icons.Filled.Add
    val Active = Icons.Filled.FiberManualRecord
    val InProgress = Icons.Filled.PlayCircle
    val Completed = Icons.Filled.CheckCircle
    // If you use custom XMLs from composeResources/drawable:
    // val CustomLogo: DrawableResource = Res.drawable.ic_logo
    
    val Privacy = Icons.Filled.Policy
    val Licenses = Icons.Filled.Info
    val ExploreWeb = Icons.Filled.Language      // "Explore on Web" link
    val PrivacyWebLink = Icons.Filled.OpenInBrowser // "Privacy Policy (Web)" link

    // Task Tracker Icons
    val Search = Icons.Default.Search
    val Clear = Icons.Default.Clear
    val Delete = Icons.Outlined.Delete
    val Edit = Icons.Outlined.Edit
    val Close = Icons.Default.Close
    val Save = Icons.Default.Save
    val Date = Icons.Default.CalendarMonth
    val Time = Icons.Default.Schedule
    val Flag = Icons.Default.Flag
    val Category = Icons.Default.Category
    val TaskCheck = Icons.Outlined.TaskAlt
    val Recurrence = Icons.Default.Repeat
    val StatsTotal = Icons.AutoMirrored.Filled.Assignment
    val StatsDone = Icons.Filled.CheckCircle
    val StatsOverdue = Icons.Filled.Warning
    val EmptyTasks = Icons.Outlined.TaskAlt
    
    val CheckBoxChecked = Icons.Default.CheckBox
    val CheckBoxUnchecked = Icons.Outlined.CheckBoxOutlineBlank
    val CheckBoxIndeterminate = Icons.Default.IndeterminateCheckBox
    val Error = Icons.Filled.Error
}

// 2. String System (Connects to generated XML resources)
object StudyStrings {
    val ToolNamePlanner = Res.string.tool_name
    val AppSubtitle = Res.string.app_subtitle
    val SettingsDesc = Res.string.settings_desc
    val AboutDesc = Res.string.about_desc
    val Sessions = Res.string.tab_sessions
    val Subjects = Res.string.tab_subjects
    val Statistics = Res.string.stats_title
    val Active = Res.string.active
    val InProgress = Res.string.in_progress
    val Completed = Res.string.completed
    val Addbtn = Res.string.btn_add

    // message
    val messageboSessions = Res.string.message_no_sessions
    val Back = Res.string.back_string
    val OK = Res.string.common_ok
    val Cancel = Res.string.common_cancel

    // About Screen
    val AboutTitle = Res.string.about_screen_title
    val AppName = Res.string.app_name
    val CompanyCredit = Res.string.company_credit
    val VersionLabel = Res.string.version_label
    val VersionFormateArgs = Res.string.version_format_args
    val VersionDesc = Res.string.version_desc
    val PrivacyPolicyTitle = Res.string.privacy_policy_title
    val PrivacyPolicyDesc = Res.string.privacy_policy_desc
    val LicensesTitle = Res.string.licenses_title
    val LicensesDesc = Res.string.licenses_desc
    val ExploreWebTitle = Res.string.explore_web_title
    val ExploreWebDesc = Res.string.explore_web_desc
    val PrivacyWebLinkTitle = Res.string.privacy_web_link_title
    val PrivacyWebLinkDesc = Res.string.privacy_web_link_desc

    // Task Tracker Strings
    val TaskTrackerTitle = Res.string.task_tracker_title
    val TaskCreateTitle = Res.string.task_create_title
    val TaskEditTitle = Res.string.task_edit_title
    val TaskTitleLabel = Res.string.task_title_label
    val TaskTitlePlaceholder = Res.string.task_title_placeholder
    val TaskDescLabel = Res.string.task_desc_label
    val TaskDeadlineLabel = Res.string.task_deadline_label
    val TaskPriorityLabel = Res.string.task_priority_label
    val TaskCategoryLabel = Res.string.task_category_label
    val TaskRecurrenceLabel = Res.string.task_recurrence_label
    
    // Task Options
    val TaskPriorityLow = Res.string.task_priority_low
    val TaskPriorityMedium = Res.string.task_priority_medium
    val TaskPriorityHigh = Res.string.task_priority_high
    val TaskPriorityUrgent = Res.string.task_priority_urgent
    
    val TaskCategoryAssignment = Res.string.task_category_assignment
    val TaskCategoryExamPrep = Res.string.task_category_exam_prep
    val TaskCategoryProject = Res.string.task_category_project
    val TaskCategoryReading = Res.string.task_category_reading
    val TaskCategoryPractice = Res.string.task_category_practice
    val TaskCategoryRevision = Res.string.task_category_revision
    val TaskCategoryOther = Res.string.task_category_other
    
    val TaskRecurrenceNone = Res.string.task_recurrence_none
    val TaskRecurrenceDaily = Res.string.task_recurrence_daily
    val TaskRecurrenceWeekly = Res.string.task_recurrence_weekly
    val TaskRecurrenceMonthly = Res.string.task_recurrence_monthly

    val TaskStatusTodo = Res.string.task_status_todo
    val TaskStatusInProgress = Res.string.task_status_in_progress
    val TaskStatusDone = Res.string.task_status_done

    val TaskFilterAll = Res.string.task_filter_all
    val TaskFilterActive = Res.string.task_filter_active
    val TaskFilterToday = Res.string.task_filter_today
    val TaskFilterOverdue = Res.string.task_filter_overdue
    val TaskFilterCompleted = Res.string.task_filter_completed

    val TaskDetailDescription = Res.string.task_detail_description
    val TaskDetailSubject = Res.string.task_detail_subject
    val TaskDetailOverdue = Res.string.task_detail_overdue
    val TaskDetailDueDate = Res.string.task_detail_due_date
    val TaskSubjectOptionalLabel = Res.string.task_subject_optional_label

    val TaskFormatOverdueDays = Res.string.task_format_overdue_days
    val TaskFormatOverdueHours = Res.string.task_format_overdue_hours
    val TaskFormatOverdueMins = Res.string.task_format_overdue_mins
    val TaskFormatToday = Res.string.task_format_today
    val TaskFormatTomorrow = Res.string.task_format_tomorrow
    val TaskFormatDays = Res.string.task_format_days

    val TaskStatsTotal = Res.string.task_stats_total
    val TaskStatsDone = Res.string.task_stats_done
    val TaskStatsOverdue = Res.string.task_stats_overdue
    val TaskEmptyTitle = Res.string.task_empty_title

    //val TaskEmptyTitle = Res.string.task_empty_title
    val TaskEmptyDesc = Res.string.task_empty_desc

    // Home Dashboard & Welcome
    val WelcomeTitle = Res.string.welcome_title
    val WelcomeDesc = Res.string.welcome_desc
    val WeeklyReviewTitle = Res.string.weekly_review_title
    val WeeklyReviewCardDesc = Res.string.weekly_review_card_desc
    val DailyFocusTitle = Res.string.daily_focus_title
    val DailyFocusOverdueFormat = Res.string.daily_focus_overdue_format
    val DailyFocusDueTodayFormat = Res.string.daily_focus_due_today_format

    val TranslatorTitle = Res.string.translator_title
    val TranslatorComingSoon = Res.string.translator_coming_soon

    // Help Screen
    val HelpScreenTitle = Res.string.help_screen_title
    val HelpScreenDesc = Res.string.help_screen_desc
    val HelpBtnReadMore = Res.string.help_btn_read_more

    val HelpFeaturePdfTitle = Res.string.help_feature_pdf_title
    val HelpFeaturePdfDesc = Res.string.help_feature_pdf_desc
    val HelpFeatureResizerTitle = Res.string.help_feature_resizer_title
    val HelpFeatureResizerDesc = Res.string.help_feature_resizer_desc
    val HelpFeatureTimerTitle = Res.string.help_feature_timer_title
    val HelpFeatureTimerDesc = Res.string.help_feature_timer_desc
    val HelpFeatureTasksTitle = Res.string.help_feature_tasks_title
    val HelpFeatureTasksDesc = Res.string.help_feature_tasks_desc
    val HelpFeaturePlannerTitle = Res.string.help_feature_planner_title
    val HelpFeaturePlannerDesc = Res.string.help_feature_planner_desc
    val HelpFeatureNotesTitle = Res.string.help_feature_notes_title
    val HelpFeatureNotesDesc = Res.string.help_feature_notes_desc
    val HelpFeatureFlashcardsTitle = Res.string.help_feature_flashcards_title
    val HelpFeatureFlashcardsDesc = Res.string.help_feature_flashcards_desc
    val HelpFeatureOcrTitle = Res.string.help_feature_ocr_title
    val HelpFeatureOcrDesc = Res.string.help_feature_ocr_desc
    val HelpFeatureTranslatorTitle = Res.string.help_feature_translator_title
    val HelpFeatureTranslatorDesc = Res.string.help_feature_translator_desc

    // Common Actions
    val ActionDelete = Res.string.common_delete
    val ActionEdit = Res.string.common_edit
    val ActionClose = Res.string.common_close
    val ActionSave = Res.string.common_save
    val ActionShare = Res.string.common_share
    val ActionOpen = Res.string.common_open
    val ActionDone = Res.string.common_done
    val ActionChange = Res.string.common_change
    val ActionMarkComplete = Res.string.common_mark_complete
    val ActionMarkIncomplete = Res.string.common_mark_incomplete
    
    // Image to PDF Tool
    val PdfToolTitle = Res.string.pdf_tool_title
    val PdfToolSubtitle = Res.string.pdf_tool_subtitle
    val PdfStep1Title = Res.string.pdf_step1_title
    val PdfStep1Subtitle = Res.string.pdf_step1_subtitle
    val PdfBtnChooseImages = Res.string.pdf_btn_choose_images
    val PdfBtnChangeImages = Res.string.pdf_btn_change_images
    val PdfStatImages = Res.string.pdf_stat_images
    val PdfStatTotalSize = Res.string.pdf_stat_total_size
    val PdfArrangeTitle = Res.string.pdf_arrange_title
    val PdfArrangeDesc = Res.string.pdf_arrange_desc
    val PdfArrangeDialogTitle = Res.string.pdf_arrange_dialog_title
    val PdfArrangePagesFormat = Res.string.pdf_arrange_pages_format
    
    val PdfStep2Title = Res.string.pdf_step2_title
    val PdfStep2Subtitle = Res.string.pdf_step2_subtitle
    val PdfBtnEditSettings = Res.string.pdf_btn_edit_settings
    val PdfLabelPageSize = Res.string.pdf_label_page_size
    val PdfLabelQuality = Res.string.pdf_label_quality
    val PdfLabelMaxSize = Res.string.pdf_label_max_size
    val PdfPlaceholderMaxSize = Res.string.pdf_placeholder_max_size
    
    val PdfStep3Title = Res.string.pdf_step3_title
    val PdfStep3Subtitle = Res.string.pdf_step3_subtitle
    val PdfBtnCreate = Res.string.pdf_btn_create
    val PdfStatusConverting = Res.string.pdf_status_converting
    val PdfSuccessMessage = Res.string.pdf_success_message
    val PdfErrorPrefix = Res.string.pdf_error_prefix
    val PdfErrorGeneric = Res.string.pdf_error_generic
    val PdfErrorSelect = Res.string.pdf_error_select
    val PdfErrorOpen = Res.string.pdf_error_open
    val PdfErrorShare = Res.string.pdf_error_share
    
    val PdfStep4Title = Res.string.pdf_step4_title
    val PdfStep4Subtitle = Res.string.pdf_step4_subtitle
    val PdfStatPages = Res.string.pdf_stat_pages
    val PdfStatFileSize = Res.string.pdf_stat_file_size
    val PdfBtnCreateAnother = Res.string.pdf_btn_create_another
    
    val PdfSizeOptimal = Res.string.pdf_size_optimal
    val PdfSizeGood = Res.string.pdf_size_good
    val PdfSizeMedium = Res.string.pdf_size_medium
    val PdfSizeLarge = Res.string.pdf_size_large
    val PdfSizeHeavy = Res.string.pdf_size_heavy

    // Image Resizer Tool
    val ResizeToolTitle = Res.string.resize_tool_title
    val ResizeToolSubtitle = Res.string.resize_tool_subtitle
    val ResizeStep1Title = Res.string.resize_step1_title
    val ResizeStep1Subtitle = Res.string.resize_step1_subtitle
    val ResizeBtnGallery = Res.string.resize_btn_gallery
    val ResizeBtnCamera = Res.string.resize_btn_camera
    val ResizeActionCrop = Res.string.resize_action_crop
    val ResizeActionRemove = Res.string.resize_action_remove
    
    val ResizeStep2Title = Res.string.resize_step2_title
    val ResizeStep2Subtitle = Res.string.resize_step2_subtitle
    val ResizeBtnEditSettings = Res.string.resize_btn_edit_settings
    val ResizeHeaderPresets = Res.string.resize_header_presets
    val ResizeChipCrop = Res.string.resize_chip_crop
    val ResizeChipRatio = Res.string.resize_chip_ratio
    val ResizeTipRatio = Res.string.resize_tip_ratio
    val ResizeHeaderCustom = Res.string.resize_header_custom
    val ResizeLabelTargetSize = Res.string.resize_label_target_size
    val ResizeLabelWidth = Res.string.resize_label_width
    val ResizeLabelHeight = Res.string.resize_label_height
    val ResizePlaceholderKb = Res.string.resize_placeholder_kb
    val ResizePlaceholderPx = Res.string.resize_placeholder_px
    val ResizeLabelQuality = Res.string.resize_label_quality
    
    val ResizeStep3Btn = Res.string.resize_step3_btn
    val ResizeStatusProcessing = Res.string.resize_status_processing
    val ResizeSuccessMessage = Res.string.resize_success_message
    val ResizeErrorStart = Res.string.resize_error_start
    val ResizeErrorPick = Res.string.resize_error_pick
    val ResizeErrorCamera = Res.string.resize_error_camera
    val ResizeErrorPermission = Res.string.resize_error_permission
    
    val ResizeStep4Title = Res.string.resize_step4_title
    val ResizeStep4Subtitle = Res.string.resize_step4_subtitle
    val ResizePreviewOriginal = Res.string.resize_preview_original
    val ResizePreviewResult = Res.string.resize_preview_result
    val ResizePreviewUnavailable = Res.string.resize_preview_unavailable

    // Settings Language
    val SettingsLanguageTitle = Res.string.settings_language_title
    val SettingsLanguageDesc = Res.string.settings_language_desc
    val LangEnglish = Res.string.lang_english
    val LangHindi = Res.string.lang_hindi

    // Quick Notes
    val NotesTitle = Res.string.notes_title
    val NotesNewNote = Res.string.notes_new_note
    val NotesSearch = Res.string.notes_search_placeholder
    val NotesFilterAll = Res.string.notes_filter_all
    val NotesFilterPinned = Res.string.notes_filter_pinned
    val NotesFilterArchived = Res.string.notes_filter_archived
    val NotesActionScan = Res.string.notes_action_scan
    val NotesActionImage = Res.string.notes_action_image
    val NotesActionTranslate = Res.string.notes_action_translate
    val NotesLabelAttachments = Res.string.notes_label_attachments
    val NotesLabelTags = Res.string.notes_label_tags
    val NotesMsgDeleted = Res.string.notes_msg_deleted
    val NotesActionUndo = Res.string.notes_action_undo
    val NotesMsgNoNotes = Res.string.notes_msg_no_notes
    val NotesMsgCreateFirst = Res.string.notes_msg_create_first
    val NotesViewFull = Res.string.notes_view_full
    val NotesArchive = Res.string.notes_archive
    val NotesUnarchive = Res.string.notes_unarchive
    val NotesPin = Res.string.notes_pin
    val NotesUnpin = Res.string.notes_unpin
    
    val NotesStatTasks = Res.string.notes_stat_tasks
    val NotesProgressLabel = Res.string.notes_progress_label
    val NotesChkViewAllFormat = Res.string.notes_chk_view_all_format
    val NotesChkAllCompleted = Res.string.notes_chk_all_completed
    val NotesChkAllCompletedEmoji = Res.string.notes_chk_all_completed_emoji
    val NotesChkTasksRemainingFormat = Res.string.notes_chk_tasks_remaining_format
    val NotesDetailsTitle = Res.string.notes_details_title
    val NotesImgFullscreenDesc = Res.string.notes_img_fullscreen_desc
    val NotesChkProgressFormat = Res.string.notes_chk_progress_format

    val ReviewTitle = Res.string.review_title
    val ReviewCompletedPrefix = Res.string.review_completed_prefix
    val ReviewCompletedSuffix = Res.string.review_completed_suffix
    val ReviewHighlights = Res.string.review_highlights
    val ReviewNoCompleted = Res.string.review_no_completed
    val ReviewMoreFormat = Res.string.review_more_format
    val ReviewNeedsAttention = Res.string.review_needs_attention
    val ReviewAllCaughtUp = Res.string.review_all_caught_up
    val ReviewPlanNext = Res.string.review_plan_next

    val OnboardingTitle = Res.string.onboarding_title
    val OnboardingSubtitle = Res.string.onboarding_subtitle
    val OnboardingContinue = Res.string.onboarding_continue

    val PersonaStudentName = Res.string.persona_student_name
    val PersonaStudentDesc = Res.string.persona_student_desc
    val PersonaProfessionalName = Res.string.persona_professional_name
    val PersonaProfessionalDesc = Res.string.persona_professional_desc
    val PersonaDeveloperName = Res.string.persona_developer_name
    val PersonaDeveloperDesc = Res.string.persona_developer_desc
    val PersonaCreatorName = Res.string.persona_creator_name
    val PersonaCreatorDesc = Res.string.persona_creator_desc
    val PersonaResearcherName = Res.string.persona_researcher_name
    val PersonaResearcherDesc = Res.string.persona_researcher_desc
    val PersonaGeneralName = Res.string.persona_general_name
    val PersonaGeneralDesc = Res.string.persona_general_desc

    // Pomodoro Timer
    val TimerTitle = Res.string.timer_title
    val TimerFocusedToday = Res.string.timer_focused_today
    val TimerHistory = Res.string.timer_history
    val TimerSettings = Res.string.timer_settings
    val TimerSessionFocus = Res.string.timer_session_focus
    val TimerSessionShortBreak = Res.string.timer_session_short_break
    val TimerSessionLongBreak = Res.string.timer_session_long_break
    val TimerMantraFocus = Res.string.timer_mantra_focus
    val TimerMantraShortBreak = Res.string.timer_mantra_short_break
    val TimerMantraLongBreak = Res.string.timer_mantra_long_break
    val TimerStatusFocusing = Res.string.timer_status_focusing
    val TimerStatusPaused = Res.string.timer_status_paused
    val TimerStatusReady = Res.string.timer_status_ready
    val TimerBtnStop = Res.string.timer_btn_stop
    val TimerBtnEnd = Res.string.timer_btn_end
    val TimerInputTask = Res.string.timer_input_task
    val TimerLabelWorkingOn = Res.string.timer_label_working_on
    val TimerRecentActivity = Res.string.timer_recent_activity
    val TimerViewAllHistory = Res.string.timer_view_all_history
    val TimerStatsToday = Res.string.timer_stats_today
    val TimerStatsWeek = Res.string.timer_stats_week
    val TimerStatsStreak = Res.string.timer_stats_streak
    
    // Pomodoro History
    val HistoryTitle = Res.string.history_title
    val HistorySubtitle = Res.string.history_subtitle
    val HistoryClearAll = Res.string.history_clear_all
    val HistoryFilterFocus = Res.string.history_filter_focus
    val HistoryFilterBreaks = Res.string.history_filter_breaks
    val HistoryDialogClearTitle = Res.string.history_dialog_clear_title
    val HistoryDialogClearMsg = Res.string.history_dialog_clear_msg
    val HistoryEmptyTitle = Res.string.history_empty_title
    val HistoryEmptyMsg = Res.string.history_empty_msg
    
    // Study Planner
    val PlannerDialogAddSessionTitle = Res.string.planner_dialog_add_session_title
    val PlannerLabelSubject = Res.string.planner_label_subject
    val PlannerLabelTopic = Res.string.planner_label_topic
    val PlannerLabelTopicUnit = Res.string.planner_label_topic_unit
    val PlannerLabelDuration = Res.string.planner_label_duration
    val PlannerDialogAddSubjectTitle = Res.string.planner_dialog_add_subject_title
    val PlannerLabelName = Res.string.planner_label_name
    val PlannerLabelCode = Res.string.planner_label_code
    val PlannerLabelHours = Res.string.planner_label_hours
    val PlannerMsgNoSessions = Res.string.planner_msg_no_sessions
    val PlannerSectionActive = Res.string.planner_section_active
    val PlannerSectionProgress = Res.string.planner_section_progress
    val PlannerSectionCompleted = Res.string.planner_section_completed
    val PlannerCardTarget = Res.string.planner_card_target
    val PlannerCardSpent = Res.string.planner_card_spent
    val PlannerCardRemaining = Res.string.planner_card_remaining
    val PlannerCardNotes = Res.string.planner_card_notes
    val PlannerBadgeCompleted = Res.string.planner_badge_completed
    val PlannerBadgeLeft = Res.string.planner_badge_left
    val PlannerDialogDeleteTitle = Res.string.planner_dialog_delete_title
    val PlannerDialogDeleteMsg = Res.string.planner_dialog_delete_msg

    // Home & Settings
    val HomeDailyFocus = Res.string.home_daily_focus
    val HomeProductivity = Res.string.home_productivity
    val HomeDocTools = Res.string.home_doc_tools
    val HomeWorkspaceTools = Res.string.home_workspace_tools
    val SettingsAppearance = Res.string.settings_appearance
    
    val SettingsTitle = Res.string.settings_title
    val SettingsCustomizeHome = Res.string.settings_customize_home
    val SettingsDailyFocusTitle = Res.string.settings_daily_focus_title
    val SettingsDailyFocusDesc = Res.string.settings_daily_focus_desc
    val SettingsWeeklyReviewTitle = Res.string.settings_weekly_review_title
    val SettingsWeeklyReviewDesc = Res.string.settings_weekly_review_desc
    val SettingsShowAllTitle = Res.string.settings_show_all_title
    val SettingsShowAllDesc = Res.string.settings_show_all_desc
    val SettingsDocToolsTitle = Res.string.settings_doc_tools_title
    val SettingsDocToolsDesc = Res.string.settings_doc_tools_desc
    val SettingsThemeMode = Res.string.settings_theme_mode
    val SettingsAppColor = Res.string.settings_app_color
    val SettingsAuto = Res.string.settings_auto
    val SettingsChangePersona = Res.string.settings_change_persona
    
    val ThemeSystem = Res.string.theme_system
    val ThemeLight = Res.string.theme_light
    val ThemeDark = Res.string.theme_dark
    
    val ColorGreen = Res.string.color_green
    val ColorBlue = Res.string.color_blue
    val ColorOrange = Res.string.color_orange
    val ColorPurple = Res.string.color_purple
    val ColorCyan = Res.string.color_cyan

    val SubjectWeeklyProgress = Res.string.subject_weekly_progress
    val TimerRecording = Res.string.timer_recording
    val TimerStop = Res.string.timer_stop
    val StatsTitle = Res.string.stats_title
    val StatsToday = Res.string.stats_today
    val StatsWeek = Res.string.stats_week
    val StatsStreak = Res.string.stats_streak
    val StatsTotal = Res.string.stats_total

    val ScreenTransition = Res.string.screen_transition
    val HeaderAlpha = Res.string.header_alpha
    val Workspace = Res.string.workspace_format
    val HelpDesc = Res.string.help_desc
    val DotSeparator = Res.string.dot_separator

    val SettingsShowAll = Res.string.settings_show_all
    val SettingsAlwaysShow = Res.string.settings_always_show

    // Features
    val FeatureImg2PdfTitle = Res.string.feature_img2pdf_title
    val FeatureImg2PdfDesc = Res.string.feature_img2pdf_desc
    val FeatureResizerTitle = Res.string.feature_resizer_title
    val FeatureResizerDesc = Res.string.feature_resizer_desc
    val FeatureTranslatorTitle = Res.string.feature_translator_title
    val FeatureTranslatorDesc = Res.string.feature_translator_desc
    val FeatureScannerTitle = Res.string.feature_scanner_title
    val FeatureScannerDesc = Res.string.feature_scanner_desc
    val FeatureTimerTitle = Res.string.feature_timer_title
    val FeatureTimerDesc = Res.string.feature_timer_desc
    val FeatureTrackerTitle = Res.string.feature_tracker_title
    val FeatureTrackerDesc = Res.string.feature_tracker_desc
    val FeaturePlannerTitle = Res.string.feature_planner_title
    val FeaturePlannerDesc = Res.string.feature_planner_desc
    val FeatureNotesTitle = Res.string.feature_notes_title
    val FeatureNotesDesc = Res.string.feature_notes_desc
    val FeatureFlashcardsTitle = Res.string.feature_flashcards_title
    val FeatureFlashcardsDesc = Res.string.feature_flashcards_desc

    val CatDocTitle = Res.string.cat_doc_title
    val CatDocDesc = Res.string.cat_doc_desc
    val CatProdTitle = Res.string.cat_prod_title
    val CatProdDesc = Res.string.cat_prod_desc
    val CatUtilTitle = Res.string.cat_util_title
    val CatUtilDesc = Res.string.cat_util_desc
}
    object StudyTheme {

        // 1. Dynamic Color Getters
        // These automatically switch based on the system theme
        val Active: Color
            @Composable
            get() = if (isSystemInDarkTheme()) StudyColors.ActiveDark else StudyColors.ActiveLight

        val Progress: Color
            @Composable
            get() = if (isSystemInDarkTheme()) StudyColors.InProgressDark else StudyColors.InProgressLight

        val Completed: Color
            @Composable
            get() = if (isSystemInDarkTheme()) StudyColors.CompletedDark else StudyColors.CompletedLight

        val Error: Color
            @Composable
            get() = if (isSystemInDarkTheme()) StudyPalette.Red200 else StudyPalette.Red600

        // 2. Helper for Random Background (Logic Layer)
        fun getRandomBackground(): Color {
            // Backgrounds usually don't change heavily in dark mode for this specific style,
            // but you could add logic here if needed.
            return StudyColors.Palette.random()
        }

        // 3. Helper for Gradients
        val BannerGradient: List<Color>
            @Composable
            get() {
                // Example: lighter gradient in dark mode to stay visible
                val start =
                    if (isSystemInDarkTheme()) StudyPalette.Teal900 else StudyColors.Palette[0]
                val end =
                    if (isSystemInDarkTheme()) StudyPalette.Cyan900 else StudyColors.Palette[4]
                return listOf(start, end)
            }

        fun getRandomGradient(): List<Color> {
            val baseColor = StudyColors.Palette.random()
            // Create a subtle gradient by fading the chosen color
            return listOf(
                baseColor,
                baseColor.copy(alpha = 0.6f)
            )
        }

        fun getRandomThreeColorGradient(): List<Color> {
            val randomSelectionColors = StudyColors.Palette.shuffled().take(3)

            return randomSelectionColors.map { color -> color.copy(alpha = 0.5f) }
        }

        @Composable
        fun getFeatureGradient(index: Int): Brush {
            val isDark = isSystemInDarkTheme()
            val palette = if (isDark) StudyColors.PaletteDark else StudyColors.PaletteLight

            // Pick a color based on index so it's deterministic (not random per recompose)
            val baseColor = palette[index % palette.size]

            // Create a subtle gradient (Top-Left to Bottom-Right)
            return if (isDark) {
                // Dark mode: Slight shine effect
                Brush.linearGradient(
                    colors = listOf(
                        baseColor.copy(alpha = 0.6f),
                        baseColor.copy(alpha = 0.3f)
                    )
                )
            } else {
                // Light mode: Clean pastel fade
                Brush.linearGradient(
                    colors = listOf(
                        baseColor,
                        Color.White.copy(alpha = 0.5f) // Fade to white for clean look
                    )
                )
            }
        }

        // Helper to get a matching content color for icons inside these cards
        @Composable
        fun getFeatureContentColor(index: Int): Color {
            // In dark mode, we want light icons. In light mode, we want dark icons.
            // You can customize this to match the specific palette color if you want even more detail.
            return MaterialTheme.colorScheme.onSurface
        }


        // 4. Hex Color Parser (Common Implementation)
        fun parseHexColor(hexString: String): Color {
            return try {
                val hex = hexString.removePrefix("#")
                val longValue = when (hex.length) {
                    6 -> "FF$hex".toLong(16) // Add alpha if missing
                    8 -> hex.toLong(16)
                    else -> 0xFF000000 // Default to black on error
                }
                Color(longValue)
            } catch (e: Exception) {
                Color.Gray // Fallback
            }
        }
    }